import apiFetch from '../apiFetch'

export default function (token, repairshop) {
  return apiFetch({ endPoint: `RepairShop/${repairshop.repairshopId}`, method: 'PUT', body: repairshop, token: token })
}
